import React from 'react';
import RenderedComponentsSingleton from 'src/common/singleton/RenderedComponentsSingleton';

interface IExtracted {
	replace: string;
	functionName: string;
	params: string[];
}

export interface IComponent<T extends object> {
	id: string;
	component: React.FunctionComponent<any>;
	props: T;
}

export const handleFunctions = (
	extracted: IExtracted[],
	rendered: string,
	ids: string[]
) => {
	let result = rendered;
	const myExtracted = [ ...extracted, ];

	const componentsToAdd: IComponent<any>[] = [];

	const prepareResources = ({
		index,
		item,
		component,
		fallback,
	}: {
		item: IExtracted;
		index: number;
		component?: IComponent<any>;
		fallback?: string;
	}) => {
		!!component && componentsToAdd.push(component);
		result = result.replace(
			item.replace,
			`<div style="flex: 1 1 0%; height: 100%; width: 100%; display: flex; align-items: center; justify-content: center;" id="${
				ids[index]
			}">${!component ? fallback : ''}</div>`
		);
	};

	// if(myExtracted.length > 1){
	//     return { components: [], html: 'ERRO: O WIDGET NÃO DEVE CONTER MAIS DE 1 COMPONENTE ', ids: [] };
	// }
	const singleton = new RenderedComponentsSingleton();
	const components = singleton.getComponents();

	myExtracted.forEach((item, index) => {
		components.forEach((component) => {
			
			if (component.name === item.functionName) {
				let props = {};
				item.params.forEach((param, index) => {
					props = { ...props, [component.props[index]]: param, };
				});
				prepareResources({
					index,
					item,
					component: {
						component: component.component,
						id: ids[index],
						props,
					},
				});
			}
		});
	});

	return { components: componentsToAdd, html: result, ids, };
};
